/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Wpm_LabelInputs */



/**
* | output |
* | --- |
* | "Words Per Minute" |
*
* @param {Style_Guide_Manager_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_wpm_label = /** @type {((inputs?: Style_Guide_Manager_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mots par minute")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter pro Minute")
	if (locale === "it") return /** @type {LocalizedString} */ ("Parole al minuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слова в минуту")
	if (locale === "es") return /** @type {LocalizedString} */ ("Palabras por minuto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟字数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたりの単語数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द प्रति मिनट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palavras por minuto")
	return /** @type {LocalizedString} */ ("Words Per Minute")
});